import { SignIn } from '@clerk/react';
import {
  Box,
  Container,
  Stack,
  Typography,
} from '@mui/material';
import { useT } from '../i18n';

export function LoginPage() {
  const t = useT();

  return (
    <Container maxWidth="xs" sx={{ mt: 8 }}>
      <Stack alignItems="center" spacing={2}>
        <Box
          component="img"
          src="/logo.png"
          alt=""
          aria-hidden
          sx={{ width: 72, height: 72, borderRadius: 2 }}
        />
        <Typography variant="h4" fontWeight={700} color="primary">
          {t('auth.brand')}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {t('auth.subtitle')}
        </Typography>
      </Stack>
      <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
        <SignIn routing="hash" />
      </Box>
      <Typography variant="caption" display="block" textAlign="center" mt={2} color="text.secondary">
        {t('auth.staffOnly')}
      </Typography>
    </Container>
  );
}
